import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { DELETABLE_STATUSES } from '../../enums/fulfillmentplan-order-grid-status';
import { messages } from './messages';

const DISABLED_STATES = {
  hasSalesOrderItems: {
    canDelete: false,
    tooltipMessage: <FormattedMessage {...messages.hasSalesOrderItems} />,
  },
  gridStatusPreventsDeletion: (gridStatus) => ({
    canDelete: false,
    tooltipMessage: <FormattedMessage {...messages.nonDeletableStatus} values={{ gridStatus }} />,
  }),
  isLoneActiveFpForSalesOrder: {
    canDelete: false,
    tooltipMessage: <FormattedMessage {...messages.loneActiveFulfillmentPlan} />,
  },
};

const doesEverySalesOrderHaveAnotherLinkedFulfillmentPlan = (salesOrdersFulfilled, fulfillmentPlanId) =>
  salesOrdersFulfilled.every((so) => so.fulfillmentPlanIds.some((fpId) => fpId !== fulfillmentPlanId));

export const useFulfillmentPlanDeleteStatus = (fulfillmentPlanId) => {
  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};
  const { items = [], orderGridStatus } = fulfillmentPlan;
  const salesOrdersFulfilled = useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );
  const fulfillmentPlanHasSalesOrderItems = items.some((item) => item.salesOrderItemId);
  if (fulfillmentPlanHasSalesOrderItems) {
    return DISABLED_STATES.hasSalesOrderItems;
  }

  const statusAllowsForDeletion = DELETABLE_STATUSES.includes(orderGridStatus);
  if (!statusAllowsForDeletion) {
    return DISABLED_STATES.gridStatusPreventsDeletion(orderGridStatus);
  }

  const isSafeToDelete = doesEverySalesOrderHaveAnotherLinkedFulfillmentPlan(salesOrdersFulfilled, fulfillmentPlanId);
  if (!isSafeToDelete) {
    return DISABLED_STATES.isLoneActiveFpForSalesOrder;
  }

  return { canDelete: true };
};

export const useFulfillmentPlanHasAdditionalItemsAndCount = (fulfillmentPlanId) => {
  const items =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'items',
      }),
    ) || [];
  return {
    hasAdditionaItems: items.some((item) => !item.salesOrderItemId),
    itemCount: items.length,
  };
};
